import strategyService from '../../../../core/services/Strategy/StrategyService';
import reducerRegistry from '../../../helpers/ReducerRegistry';
import { handleExport } from '../../../helpers/HandleExport';

import { REDUCER_NAME as CANSLIM_REDUCER_NAME } from '../canslim/reducer';
import { getParamFromSortState } from '../../../helpers/Common';

// ================================================== CONSTANTS ========================================================
const REDUCER_NAME = 'FIINTRADE_STRATEGY';
const SET_TYPE_RANKING = `${REDUCER_NAME}SET_TYPE_RANKING`;
const CHANGE_SIZE_COMPONENT = `${REDUCER_NAME}CHANGE_SIZE_COMPONENT`;
const INIT_COMPONENT = `${REDUCER_NAME}INIT_COMPONENT`;
const UNMOUNT_COMPONENT = `${REDUCER_NAME}UNMOUNT_COMPONENT`;

export { REDUCER_NAME, reducer as default, setTypeRanking };

function setTypeRanking(type) {
  return dispatch => {
    dispatch({
      type: SET_TYPE_RANKING,
      payload: {
        typeRanking: type,
      },
    });
  };
}

const initialState = {
  listFormatTick: [],
  typeRanking: 'industry',
  component: {},
};

export const downloadScore = (
  StrategyScoreType,
  reducerName = 'ST_VALUE',
  fileName = 'export-file',
) => {
  return (dispatch, getState) => {
    const {
      currentSelectedIndustryTable: { icbCode },
    } = getState()[reducerName];
    strategyService
      .downloadScore({
        StrategyScoreType,
        IcbCode: icbCode === 'all' ? null : icbCode,
        // PageSize: 50,
        // Page: 1
      })
      .then(response => {
        handleExport(response, fileName);
      });
  };
};

export const downloadCanSlim = (fileName = 'export-file') => {
  return (dispathc, getState) => {
    const sortState = getState()[CANSLIM_REDUCER_NAME].sortState;
    const params = {
      ...getState()[CANSLIM_REDUCER_NAME].apiParams,
      ...getParamFromSortState(sortState),
    };
    strategyService.downloadCanSlim(params).then(response => {
      handleExport(response, fileName);
    });
  };
};

function reducer(state = {}, action) {
  switch (action.type) {
    case INIT_COMPONENT:
      return {
        ...state,
        ...initialState,
      };

    case UNMOUNT_COMPONENT:
      return {};

    case SET_TYPE_RANKING: {
      const { typeRanking } = action.payload;
      return {
        ...state,
        typeRanking,
      };
    }

    case CHANGE_SIZE_COMPONENT: {
      return {
        ...state,
        component: action.payload,
      };
    }

    default:
      return state;
  }
}

reducerRegistry.register(REDUCER_NAME, reducer);
